var nsfCartData = {
    fetchReq: undefined,

    removeSelectors: [
        '.js-cart-remove',
        '[data-ajax-qty-decrease]'
    ],

    init: function () {
        this.fetchData();
        this._bindCartUpdateEvent();
    },

    fetchData: function () {
        let self = this;

        if (self.fetchReq !== undefined) {
            self.fetchReq.abort();
        }

        self.fetchReq = $.getJSON('/cart.js', function (cart) {
            self._updateLocalCart(cart);
        });
    },

    _cartDiff: function (a, b) {
        let hash = [];
        let diff = [];

        for (let i = 0; i < a.items.length; i++) {
            hash[a.items[i].variant_id] = a.items[i];
        }

        for (let i = 0; i < b.items.length; i++) {
            if (hash[b.items[i].variant_id] === undefined) {
                diff.push(JSON.parse(JSON.stringify(b.items[i])));
                continue;
            }

            if (hash[b.items[i].variant_id].quantity < b.items[i].quantity) {
                let tmpItem = JSON.parse(JSON.stringify(b.items[i]));
                tmpItem.quantity = b.items[i].quantity - hash[b.items[i].variant_id].quantity;
                diff.push(tmpItem);
            }
        }

        return diff;
    },

    _getLocalCart: function () {
        let nsfCart = localStorage.getItem('nsf_cart');

        if (nsfCart === null || nsfCart.length <= 0) {
            return {items:[]};
        }

        return JSON.parse(nsfCart);
    },

    _updateLocalCart: function (cart) {
        let isEmpty = cart.items.length === 0;

        let localCart = this._getLocalCart();
        localStorage.setItem('nsf_cart', JSON.stringify(cart));

        $(document).trigger('nsf:cart-update', [cart]);
        $(document).trigger('nsf:add-to-cart', [this._cartDiff(localCart, cart)]);

        if (this._isCartRemove() || !isEmpty) {
            $(document).trigger('nsf:remove-from-cart', [this._cartDiff(cart, localCart)]);
            this._setCartRemove(0);
        }
    },

    _bindCartUpdateEvent: function () {
        let self = this;

        $(document).on('theme:cart-update', function () {
            self.fetchData();
        });

        // set remove event
        $(document).on('click', function (e) {
            for (let selector of self.removeSelectors) {
                if ($(selector).is(e.target) || $(selector).has(e.target).length > 0) {
                    self._setCartRemove(1);
                }
            }
        })
    },

    _setCartRemove: function (flag = 1) {
        localStorage.setItem('nsf_cart_remove', flag);
    },

    _isCartRemove: function () {
        return localStorage.getItem('nsf_cart_remove') === '1';
    }
}

var nsfGa4 = {
    ajaxWrapper: [
        'div.js-product-rec-wrapper',
    ],

    init: function () {
        this._reportDomData();
        this._bindAjaxUpdateDomEvent();
        this._bindAddToCartEvent();
        this._bindRemoveFromCartEvent();
    },

    _reportDomData: function () {
        let self = this;

        $('[data-nsf="ga4-data"][data-status="1"]').each(function () {
            self._reportGa4Data($(this));
        });
    },

    _reportGa4Data: function ($dataWrapper) {
        let type = $dataWrapper.attr('data-type');
        let data = JSON.parse($dataWrapper.html());

        if (type === 'collection') {
            this._reportCollectionData(data);
        }

        if (type === 'product') {
            this._reportProductData(data)
        }

        $dataWrapper.attr('data-status', 0);
    },

    _reportCollectionData: function (data) {
        setTimeout(function () {
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "view_item_list",
                ecommerce: {
                    items: data
                }
            });
        }, 200);
    },

    _reportProductData: function (data) {
        setTimeout(function () {
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "view_item",
                ecommerce: {
                    items: data
                }
            });
        }, 200);
    },

    _bindAjaxUpdateDomEvent: function () {
        let self = this;

        let mo = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                if ($(m.target).is($('div.js-product-rec-wrapper')) && m.addedNodes.length > 1) {
                    return;
                }
                
                for (let node of m.addedNodes) {
                    self._reportAjaxDomData($(node));
                }
            })
        })

        for (const wrapper of this.ajaxWrapper) {
            if (wrapper.length <= 0) {
                continue;
            }

            $(wrapper).each(function () {
                mo.observe($(this)[0], {
                    childList: true
                });
            })
        }
    },

    _reportAjaxDomData: function ($node) {
        let $dataWrapper = $node.find('[data-nsf="ga4-data"][data-status="1"]');

        if ($dataWrapper.length <= 0) {
            return;
        }

        return this._reportGa4Data($dataWrapper);
    },

    _bindAddToCartEvent: function () {
        $(document).on('nsf:add-to-cart', function (e, data) {
            if (data.length <= 0) {
                return ;
            }

            let fmtData = data.map(function (item) {
                return {
                    item_name: item.title,
                    item_id: item.variant_id,
                    price: (item.price / 100).toFixed(2),
                    item_brand: item.vendor,
                    item_category: '',
                    item_category2: '',
                    item_category3: '',
                    item_category4: '',
                    item_variant: item.variant_options.join(' / '),
                    item_list_name: '',
                    item_list_id: '',
                    index: 1,
                    quantity: item.quantity
                }
            });

            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                    items: fmtData
                }
            });
        });
    },

    _bindRemoveFromCartEvent: function () {
        $(document).on('nsf:remove-from-cart', function (e, data) {
            if (data.length <= 0) {
                return ;
            }

            let fmtData = data.map(function (item) {
                return {
                    item_name: item.title,
                    item_id: item.variant_id,
                    price: (item.price / 100).toFixed(2),
                    item_brand: item.vendor,
                    item_category: '',
                    item_category2: '',
                    item_category3: '',
                    item_category4: '',
                    item_variant: item.variant_options.join(' / '),
                    item_list_name: '',
                    item_list_id: '',
                    index: 1,
                    quantity: item.quantity
                }
            });

            window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            window.dataLayer.push({
                event: "remove_from_cart",
                ecommerce: {
                    items: fmtData
                }
            });
        });
    }
}

$(document).ready(function () {
    nsfCartData.init();
    nsfGa4.init();
});